import React, { useEffect, useRef, useState } from "react";
import { Field } from "react-final-form";
import CloseIcon from "@rsuite/icons/Close";
import { useTranslation } from "react-i18next";
import { getBasename, isValidURL } from "../../../utils/helpers";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { Button } from "rsuite";
import {
  maxUploadSizeInMB,
  messageTypeArr,
} from "../../../core/config/AppConstants";
interface ImageUploadProps {
  name?: string;
  accept?: string;
  label?: string;
  browseLabel?: string;
  entityImageFile?: any;
  entityImage?: any;
  setEntityImageFile?: any;
  maxUploadSize?: number;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  name = "_image",
  accept = "image/png, image/gif, image/jpeg",
  label = "UPLOAD Image",
  browseLabel = "BROWSE",
  entityImageFile = null,
  entityImage = null,
  setEntityImageFile = null,
  maxUploadSize = maxUploadSizeInMB,
}) => {
  const { t } = useTranslation();
  const ImageUpload = useRef<HTMLInputElement | null>(null);
  const fileUploadSize = maxUploadSize * 1024 * 1024;

  const resetFile = (e: any) => {
    e.preventDefault();

    setEntityImageFile(null);
  };

  return (
    <Field name={name}>
      {({ input }) => (
        <div className="flex-item">
          <div className="d-flex song-img">
            <div>
              <img
                className="song-img-bx mb-2"
                src={
                  !entityImage
                    ? UtilityServices.getLoggedInUser("song_default_image")
                    : entityImage
                }
                alt="deafult image"
                style={{ maxHeight: "100px", width: "auto" }}
              />
            </div>
            <input
              id="image-upload"
              ref={ImageUpload}
              type="file"
              accept="image/png, image/gif, image/jpeg"
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              onChangeCapture={(e: any) => {
                const file = e.target.files[0];
                if (!file) {
                  setEntityImageFile(null);
                  input.onChange(null);
                  return;
                }
                if (file && file.size > fileUploadSize) {
                  UtilityServices.showToaster({
                    message: t("FILE_SIZE_LESS_THAN", {
                      field: t("IMAGE"),
                      value: maxUploadSize,
                    }),
                    type: messageTypeArr.error,
                  });
                  e.target.value = "";
                  setEntityImageFile(null);
                  input.onChange(null);
                  return;
                }
                if (file) {
                  setEntityImageFile(file);
                  input.onChange(file);
                }
              }}
              style={{ display: "none" }}
            />
            <label
              className="song-image-upload-lbl me-2"
              htmlFor="image-upload"
            >
              {label ? label : t("UPLOAD")}
            </label>
            {entityImage && (
              <Button
                appearance="link"
                color="red"
                onClick={(e: any) => resetFile(e)}
              >
                <CloseIcon />
              </Button>
            )}
            <Button
              className="song-file-upload-lbl mb-4"
              appearance="ghost"
              onClick={() => {
                if (ImageUpload.current) {
                  ImageUpload.current.click();
                }
              }}
            >
              {" " + t(browseLabel) + " "}
            </Button>
          </div>
        </div>
      )}
    </Field>
  );
};

export default ImageUpload;
